import {
  ChartCard,
  ChartCardFooter,
  chartDefaultWeekDataObject,
  ChartNoDataFound,
  ChartsTooltip,
  getFillAndStrokeColors,
  useEffect,
  useState,
  weekDaysToArrayOfObjects,
} from "@";
import { Area, AreaChart, ResponsiveContainer, Tooltip, XAxis } from "recharts";
import {
  useAbandonedCartsQuery,
  useGiftOrdersQuery,
  useRecurrentOrdersQuery,
} from "../utils/queries.js";

// Chart component to render an area chart with a card layout
const Chart = ({ title, prefix, queryType = "recurrentOrders" }) => {
  const [data, setData] = useState(chartDefaultWeekDataObject);
  const [strokeColor, setStrokeColor] = useState("#4E1AC7");
  const [fillColor, setFillColor] = useState("url(#colorDonationBlue)");
  const [searchDuration, setSearchDuration] = useState(3);

  // Select the appropriate query hook based on queryType
  const queries = {
    recurrentOrders: useRecurrentOrdersQuery,
    giftOrders: useGiftOrdersQuery,
    abandonedCarts: useAbandonedCartsQuery,
  };

  const useQueryHook = queries[queryType] || useRecurrentOrdersQuery;
  const { data: queryData } = useQueryHook(searchDuration);

  // Update the chart data and colors based on the fetched results
  const updateChartData = (res) => {
    if (!res) {
      setData(chartDefaultWeekDataObject);
      return;
    }

    const updatedData = weekDaysToArrayOfObjects(res);
    setData(updatedData);

    const { fillColor, strokeColor } = getFillAndStrokeColors(
      updatedData.percentage,
    );
    setFillColor(fillColor);
    setStrokeColor(strokeColor);
  };

  // Fetch data based on the duration
  const fetchData = (value) => {
    setSearchDuration(value);
  };

  useEffect(() => {
    if (queryData) {
      updateChartData(queryData);
    }
  }, [queryData]);

  return (
    <ChartCard searchDurationUpdated={fetchData} title={title}>
      <div className="-mx-2 h-40 lg:-mx-4">
        {data?.weekDays?.length > 0 ? (
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart
              width={200}
              height={60}
              data={data.weekDays}
              margin={{ top: 30 }}
            >
              <XAxis reversed dataKey="key" display="none" />
              <defs>
                <linearGradient
                  id="colorDonationBlue"
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="1"
                >
                  <stop offset="0%" stopColor="#57009466" />
                  <stop offset="100%" stopColor="#4E1AC7" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                  id="colorDonationRed"
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="1"
                >
                  <stop offset="0%" stopColor="#FB3E3E33" />
                  <stop offset="100%" stopColor="#FFFFFF00" stopOpacity={0} />
                </linearGradient>
              </defs>
              <Tooltip
                content={
                  <ChartsTooltip
                    prefix={prefix === "سلة" ? "عدد السلات" : "عدد الطلبات"}
                  />
                }
              />
              <Area
                type="monotone"
                dataKey="value"
                strokeWidth={2}
                stroke={strokeColor}
                fill={fillColor}
              />
            </AreaChart>
          </ResponsiveContainer>
        ) : (
          <ChartNoDataFound />
        )}
      </div>
      <ChartCardFooter
        prefix={prefix}
        number={data?.total}
        percent={data?.percentage}
        searchDuration={searchDuration}
      />
    </ChartCard>
  );
};

export default Chart;
